<template>
  <div>
    <div class="page-head">
      <div>
        <h2>高端定制管理</h2>
        <p>控制小程序高端定制入口、核心承诺和需求提交页展示内容。</p>
      </div>
    </div>

    <el-card shadow="never" v-loading="loading">
      <el-form class="drawer-form" :model="form" label-width="120px">
        <el-form-item label="页面标签">
          <el-input v-model="form.title" maxlength="12" show-word-limit />
          <div class="field-help">Hero 最上方的小标签，例如“高端定制游”。</div>
        </el-form-item>
        <el-form-item label="核心标题">
          <el-input v-model="form.subtitle" maxlength="18" show-word-limit />
          <div class="field-help">只表达一个核心利益点，例如“先出方案，再做决定”。</div>
        </el-form-item>
        <el-form-item label="头图"><asset-upload v-model="form.hero_url" category="custom-service" /></el-form-item>
        <el-form-item label="一句话说明">
          <el-input v-model="form.description" type="textarea" :rows="2" maxlength="36" show-word-limit />
          <div class="field-help">Hero 中只展示这一句，避免重复核心标题。</div>
        </el-form-item>
        <el-form-item label="核心卖点">
          <el-input v-model="valuesText" type="textarea" :rows="5" placeholder="一行一个：标题｜说明｜图标键" />
        </el-form-item>
        <el-form-item label="服务方式">
          <el-input v-model="processText" type="textarea" :rows="5" placeholder="一行一个：标题｜说明｜图标键；序号按行自动生成" />
        </el-form-item>
        <el-form-item label="服务包含">
          <el-input v-model="includeText" type="textarea" :rows="5" placeholder="一行一个：标题｜说明｜图标键" />
          <div class="field-help">图标键示例：shield、consultant、car、hotel、edit、calendar、guide。</div>
        </el-form-item>
        <el-form-item label="方案确认说明">
          <el-input v-model="form.notice" type="textarea" :rows="2" maxlength="80" show-word-limit />
          <div class="field-help">展示在服务流程区域，不进入头图。</div>
        </el-form-item>
        <el-form-item label="展示状态">
          <el-select v-model="form.status">
            <el-option label="展示中" value="active" />
            <el-option label="已隐藏" value="inactive" />
          </el-select>
        </el-form-item>
      </el-form>
      <div class="drawer-footer">
        <el-button type="primary" :loading="saving" @click="save">保存高端定制</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import AssetUpload from "../components/AssetUpload.vue";
import { createResource, listResource, updateResource } from "../api/resources";

export default {
  name: "CustomServiceManage",
  components: { AssetUpload },
  data() {
    return {
      loading: false,
      saving: false,
      valuesText: "",
      processText: "",
      includeText: "",
      form: this.emptyForm()
    };
  },
  mounted() {
    this.fetchConfig();
  },
  methods: {
    emptyForm() {
      return {
        title: "高端定制游",
        subtitle: "先出方案，再做决定",
        badge: "",
        hero_url: "",
        description: "专属定制师 1 对 1 沟通，无需前期定金",
        notice: "确认方案后，按最终一价全含服务方案支付。",
        status: "active",
        sort_order: 0
      };
    },
    async fetchConfig() {
      this.loading = true;
      try {
        const res = await listResource("custom-service-config", { page: 1, pageSize: 1 });
        const row = res.data && res.data.items && res.data.items[0];
        this.form = { ...this.emptyForm(), ...(row || {}) };
        this.valuesText = this.itemsToText(this.parseJson(this.form.values_json || this.form.values));
        this.processText = this.itemsToText(this.parseJson(this.form.process_json || this.form.process || this.form.flow));
        this.includeText = this.itemsToText(this.parseJson(this.form.include_json || this.form.includes));
      } finally {
        this.loading = false;
      }
    },
    itemsToText(items) {
      const list = Array.isArray(items) ? items : [];
      return list.map((item) => {
        if (typeof item === "string") return item;
        return [item.title || item.name || "", item.description || item.desc || "", item.icon_key || ""].join("｜").replace(/｜+$/, "");
      }).join("\n");
    },
    parseJson(value) {
      if (!value) return [];
      if (Array.isArray(value)) return value;
      try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : [];
      } catch (error) {
        return [];
      }
    },
    lines(value) {
      return String(value || "").split("\n").map((item) => item.trim()).filter(Boolean);
    },
    buildPayload() {
      return {
        ...this.form,
        badge: null,
        values_json: this.lines(this.valuesText).map((line) => this.parseItem(line)),
        process_json: this.lines(this.processText).map((line, index) => this.parseItem(line, index)),
        include_json: this.lines(this.includeText).map((line) => this.parseItem(line))
      };
    },
    parseItem(line, index) {
      const [title = "", description = "", iconKey = ""] = line.split("｜");
      return {
        ...(index === undefined ? {} : { index: String(index + 1).padStart(2, "0") }),
        title: title.trim(),
        description: description.trim(),
        icon_key: iconKey.trim()
      };
    },
    async save() {
      this.saving = true;
      try {
        const payload = this.buildPayload();
        if (payload.id) await updateResource("custom-service-config", payload.id, payload);
        else await createResource("custom-service-config", payload);
        this.$message.success("高端定制配置已保存");
        this.fetchConfig();
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
.field-help { margin-top: 6px; color: #909399; font-size: 12px; line-height: 1.5; }
</style>
